import { SectionData } from '../../../annotations/models/annotationData';
import { QueueAction, QueueRule } from '../../../rules/models/queueRule';
import { Message } from '../../../shared/models/message';
import { Url } from '../../../utils/codecUtils';
import {
  evaluateRulesPayloadSchema,
  evaluateRulesResponseSchema,
} from './evaluateRules.schema';

export type EvaluateRulesPayload = {
  queue: Url;
  annotationContent?: Array<SectionData>;
  schemaRules: Array<Partial<QueueRule>>;
  annotation?: Url;
};

export type EvaluateRulesResponse = {
  conditionValues: Array<Array<boolean>>;
  messages: Array<Message>;
  actions: Array<QueueAction>;
};

export const evaluateRules = (payload: EvaluateRulesPayload) => {
  return {
    endpoint: `internal/rules/evaluate_rules`,
    method: 'POST',
    responseSchema: evaluateRulesResponseSchema,
    payloadSchema: evaluateRulesPayloadSchema,
    payload,
  } as const;
};
